import { createRouteRef } from '@backstage/frontend-plugin-api';

export const approvalsListRouteRef = createRouteRef();
export const approvalDetailsRouteRef = createRouteRef({
  params: ['id'],
});
